<!--@if ({ isTop: isTopNav$ | async }; as navigation) {-->
<!--    @if (showHeader()) {-->
<!--        <header [ngClass]="{ 'header&#45;&#45;top-nav-transparent-sticky': isTopNavTransparentSticky }" class="header">-->
<a
    (click)="goToMain('main-content')"
    [core-analytics]="{ action: 'Skip to main content', category: 'HEADER' }"
    class="skip-to-content visually-hidden-focusable"
    href="javascript:void(0)">
    <span class="skip-to-content__link">Skip to main content</span>
</a>
<!--            @if (!navigation.isTop) {-->
<!--                <core-side-nav></core-side-nav>-->
<!--            }-->
<!--            @if (navigation.isTop) {-->
<!--                <core-top-navigation></core-top-navigation>-->
<!--            }-->
<!--        </header>-->
<!--    }-->
<!--}-->
